
export const getBalanceType = (type: string) => {
  switch (type) {
    case 'cash':
      return 'Tiền mặt';
    case 'point':
      return 'Điểm';
    default:
      break;
  }
}

export const getType = (type: string) => {
  //deposit|withdrawal|spend|reward
  switch (type) {
    case 'deposit':
      return [{color: 'green', label: 'Nạp tiền'}];
    case 'withdrawal':
      return [{color: 'red', label: 'Rút tiền'}];
    case 'spend':
      return [{color: 'red', label: 'Sử dụng'}];
    case 'reward':
      return [{color: 'blue', label: 'Thưởng'}];
    default:
      break;
  }
}

const getAmount = (item: object) => {
  if(!item?.transaction_type || !item?.amount) return 0
  switch (item.transaction_type) {
    case 'deposit':
      return item.amount
    case 'withdrawal':
      return - item.amount
    case 'spend':
      return - item.amount
    case 'reward':
      return item.amount
    default:
      return 0
  }
}


export const formatTableDataTransaction = (data: any[]) => {
  //convert data to array
  return data.map((item) => ({
    ...item,
    amount: getAmount(item),
    balance_type: getBalanceType(item?.balance_type) || '-',
    transaction_type: getType(item?.transaction_type) || '-',
    account_code: item?.user.code || '',
    phone: item?.user?.phone_number || '',
    full_name: item?.user?.full_name || '',
    action_by: item?.deposit_transaction?.admin?.full_name || '-',
    created_at: item.created_at ? item.created_at : '',
    action: item,
  }));
}

export const getStatusTransactionWithdraw = (status: string) => {
  switch (status) {
    case 'requested':
      return [{ label: 'Đang chờ xử lí', type: 'secondary' }];
    case 'paid':
      return [{ label: 'Đã xử lí', type: 'success' }];
    case 'rejected':
      return [{ label: 'Đã từ chối', type: 'danger' }];
    default:
      break;
  }
}

export const formatTableDataTransactionWithdraw = (data: any[]) => {
  //convert data to array
  return data.map((item) => ({
    ...item,
    amount: - item.amount,
    note: item.note || '-',
    status: getStatusTransactionWithdraw(item.status),
    balance_type: getBalanceType('cash') || '-',
    transaction_type: getType('withdrawal') || '-',
    account_code: item?.requestor.code || '',
    phone: item?.requestor?.phone_number || '',
    full_name: item?.requestor?.full_name || '',
    action_by: '-',
    created_at: item.created_at ? item.created_at : '',
    action: item,
  }));
}
